import { render, staticRenderFns } from "./BarChartRankingArrecadacao.vue?vue&type=template&id=8981b60c"
import script from "./BarChartRankingArrecadacao.vue?vue&type=script&lang=js"
export * from "./BarChartRankingArrecadacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports